var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0151 15.3186C33.9572 15.1593 34.0729 15 34.2466 15H47.5028C47.908 15 48.1396 15.4248 47.908 15.7434L44.3769 20.7345C44.2611 20.8938 44.2611 21.1062 44.3769 21.2655L47.908 26.2566C48.1396 26.5752 47.908 27 47.5028 27H34.2466C34.0729 27 33.9572 26.8407 34.0151 26.6814C34.2466 26.1504 34.5939 25.6726 35.057 25.3009L37.0831 23.708C38.8197 22.3274 38.8197 19.6726 37.0831 18.292L35.057 16.6991C34.5939 16.3274 34.2466 15.8496 34.0151 15.3186Z",
    fill: "url(#paint0_linear_28_270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7919 18.6094L34.0085 17.2268C33.1456 16.5932 32.7429 15.4986 32.858 14.4617L33.1456 12.2151C33.3757 10.2565 31.7074 8.58596 29.7515 8.81638L27.5079 9.10441C26.4724 9.21962 25.3793 8.81638 24.7465 7.95229L23.3658 6.16652C22.1578 4.61116 19.7991 4.61116 18.591 6.16652L17.2103 7.95229C16.5775 8.81638 15.4845 9.21962 14.449 9.10441L12.2054 8.81638C10.2494 8.58596 8.58112 10.2565 8.81124 12.2151L9.09888 14.4617C9.21393 15.4986 8.81124 16.5932 7.94831 17.2268L6.16494 18.6094C4.61169 19.8191 4.61169 22.1809 6.16494 23.3906L7.94831 24.7732C8.81124 25.4068 9.21393 26.5014 9.09888 27.5383L8.81124 29.7849C8.58112 31.7435 10.2494 33.414 12.2054 33.1836L14.449 32.8956C15.4845 32.7804 16.5775 33.1836 17.2103 34.0477L18.591 35.8335C19.7991 37.3888 22.1578 37.3888 23.3658 35.8335L24.7465 34.0477C25.3793 33.1836 26.4724 32.7804 27.5079 32.8956L29.7515 33.1836C31.7074 33.414 33.3757 31.7435 33.1456 29.7849L32.858 27.5383C32.7429 26.5014 33.1456 25.4068 34.0085 24.7732L35.7919 23.3906C37.4027 22.2385 37.4027 19.8191 35.7919 18.6094ZM20.9497 32.9532C14.3915 32.9532 9.04135 27.5959 9.04135 21.0288C9.04135 14.4617 14.3915 9.10441 20.9497 9.10441C27.5079 9.10441 32.858 14.4617 32.858 21.0288C32.858 27.5959 27.5079 32.9532 20.9497 32.9532Z",
    fill: "url(#paint1_linear_28_270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.067 11C15.5925 11 11.1339 15.4886 11.1339 21C11.1339 26.5114 15.5925 31 21.067 31C26.5414 31 31 26.5114 31 21C31 15.4886 26.5414 11 21.067 11ZM26.3721 18.8409L19.9946 25.0909C19.8253 25.2614 19.5996 25.2614 19.4303 25.0909L15.7054 21.2841C15.536 21.1136 15.536 20.8864 15.7054 20.7159L17.1727 19.3523C17.3421 19.1818 17.5678 19.2386 17.7371 19.3523L19.4867 21.2841C19.656 21.4545 19.8818 21.4545 20.0511 21.2841L24.3968 16.9091C24.5661 16.7386 24.7918 16.7386 24.9612 16.9091L26.3721 18.2727C26.5414 18.4432 26.5414 18.6705 26.3721 18.8409ZM7.63476 27.0795C7.69119 27.25 7.57832 27.4205 7.409 27.4205H-5.51525C-5.91032 27.4205 -6.13607 26.9659 -5.91032 26.625L-2.46761 21.2841C-2.35474 21.1136 -2.35474 20.8864 -2.46761 20.7159L-5.91032 15.375C-6.13607 15.0341 -5.91032 14.5795 -5.51525 14.5795H7.409C7.57832 14.5795 7.69119 14.75 7.63476 14.9205C7.409 15.4886 7.07038 16 6.61887 16.3977L4.64355 18.1023C2.95042 19.5795 2.95042 22.4205 4.64355 23.8977L6.61887 25.6023C7.07038 26 7.409 26.5114 7.63476 27.0795Z",
    fill: "url(#paint2_linear_28_270)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_270",
    x1: 34.1515,
    y1: 15.7176,
    x2: 47.1778,
    y2: 17.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1756CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_270",
    x1: 5.34618,
    y1: 6.91361,
    x2: 35.2452,
    y2: 10.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1756CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_270",
    x1: -5.59973,
    y1: 12.196,
    x2: 28.028,
    y2: 18.9284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1756CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174BCF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIcon);
export default __webpack_public_path__ + "static/media/reward-icon.58383423fe7121af307641322aeb8c44.svg";
export { ForwardRef as ReactComponent };